import React, { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Button } from '@mui/material'
import { toast } from 'react-toastify'
import { BACKEND_URI } from '../config'



function ChangePassword() {
  const navigate = useNavigate()
  const [newPassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [errorMessage, setErrorMessage] = useState('')
  const { token } = useParams()

  const handleSubmit = async e => {
    if (newPassword !== confirmPassword) {
      setErrorMessage('Passwords must match')
      return
    }

    try {
      const response = await fetch(`${BACKEND_URI}/api/reset-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ token, newPassword }),
      })

      const data = await response.json()

      // Handle response
      if (!response.ok) {
        throw new Error(data.error || 'An error occurred')
      }

      toast.success('Password Changed Successfully!')
      navigate('/')
    } catch (err) {
      setErrorMessage(err.message || 'Invalid token')
    }
  }

  return (
    <div style={styles.container}>
      <div style={styles.formContainer}>
        <div style={styles.inputGroup}>
          <label>New Password</label>
          <input
            type='password'
            placeholder='Enter new password'
            value={newPassword}
            onChange={e => setNewPassword(e.target.value)}
            style={styles.input}
          />
        </div>

        <div style={styles.inputGroup}>
          <label>Confirm New Password</label>
          <input
            type='password'
            placeholder='Confirm new password'
            value={confirmPassword}
            onChange={e => setConfirmPassword(e.target.value)}
            style={styles.input}
          />
        </div>

        <Button
          onClick={handleSubmit}
          variant='contained'
          color='primary'
          style={styles.changePasswordButton}
        >
          Set New Password
        </Button>
        <div />
        <small style={{ color: 'red' }}>{errorMessage}</small>
      </div>
    </div>
  )
}

const styles = {
  forgotLink: {
    background: 'none',
    border: 'none',
    color: '#007BFF',
    cursor: 'pointer',
    fontSize: '14px',
    padding: '5px',
    display: 'block', // Forces the button to take full width
    textAlign: 'right', // Aligns text inside button to the right
    width: '100%', // Ensures alignment works properly
  },
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    backgroundColor: '#f5f5f5',
  },
  formContainer: {
    backgroundColor: '#fff',
    padding: '2rem',
    borderRadius: '8px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    width: '300px',
    textAlign: 'center',
  },
  nameContainer: {
    display: 'flex', // Enable flexbox
    justifyContent: 'space-between', // Add space between the inputs
    gap: '1rem', // Space between First Name and Last Name inputs
    marginBottom: '1rem', // Add space below the row
    marginTop: '1rem',
  },
  nameInputGroup: {
    flex: 1, // Make each input take equal space
    textAlign: 'left',
  },
  inputGroup: {
    marginBottom: '1rem',
    textAlign: 'left',
  },
  input: {
    width: '100%',
    padding: '0.5rem',
    borderRadius: '4px',
    border: '1px solid #ccc',
    marginTop: '0.5rem',
    boxSizing: 'border-box',
  },
  button: {
    width: '100%',
    padding: '0.75rem',
    borderRadius: '4px',
    border: 'none',
    backgroundColor: '#007BFF',
    color: '#fff',
    fontWeight: 'bold',
    cursor: 'pointer',
  },
  toggleText: {
    marginTop: '1rem',
    fontSize: '0.9rem',
  },
  toggleLink: {
    color: '#007BFF',
    cursor: 'pointer',
    textDecoration: 'underline',
  },
}

export default ChangePassword
